export const toolsPosts = [
  {
    id: 't1',
    user_id: 'user56',
    type: 'feed' as const,
    category: 'tools',
    title: 'Burp Suite 2025 신기능 완벽 가이드 - AI 보조 스캐너 활용법',
    content: 'Burp Suite Professional 2025.1에 추가된 AI 기반 취약점 스캐너를 실전에서 테스트했습니다. 기존 스캐너 대비 IDOR 탐지율이 40% 향상됐고, GraphQL 인트로스펙션 자동 분석 기능도 매우 유용합니다. 새로운 Bambda 필터 문법과 함께 실전 팁을 공유합니다.',
    tags: ['burpsuite', 'web-security', 'tools', '2025', 'scanner'],
    status: 'open',
    is_pinned: false,
    likes_count: 1876,
    replies_count: 72,
    views_count: 14300,
    created_at: new Date(Date.now() - 2 * 3600000).toISOString(),
    profiles: {
      id: 'user56',
      username: 'burp_master',
      display_name: 'Burp Master',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 't2',
    user_id: 'user57',
    type: 'feed' as const,
    category: 'tools',
    title: 'Nuclei 3.0 템플릿 작성 가이드 - 커스텀 취약점 탐지',
    content: 'Nuclei 3.0의 새로운 기능과 효과적인 템플릿 작성 방법을 정리했습니다. 동적 변수, 헬퍼 함수, 조건부 매칭 등 고급 기능을 활용하여 복잡한 취약점도 탐지할 수 있습니다. 실제 버그바운티에서 사용한 커스텀 템플릿 20개를 공유합니다.',
    tags: ['nuclei', 'vulnerability-scanner', 'yaml', 'automation', 'bugbounty'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 61,
    views_count: 11800,
    created_at: new Date(Date.now() - 4 * 3600000).toISOString(),
    profiles: {
      id: 'user57',
      username: 'nuclei_dev',
      display_name: 'Nuclei Developer',
      points: 12340,
      reputation: 3780
    }
  },
  {
    id: 't3',
    user_id: 'user58',
    type: 'feed' as const,
    category: 'tools',
    title: 'Ghidra 11.0 새로운 디컴파일러 - 리버싱 효율 2배 향상',
    content: 'Ghidra 11.0의 개선된 디컴파일러를 실전에서 테스트했습니다. C++ 템플릿과 가상 함수 테이블 분석이 크게 개선됐고, Rust 바이너리 지원도 추가됐습니다. 새로운 타입 추론 엔진 덕분에 리버싱 시간이 절반으로 단축됐습니다. 실전 활용 팁을 공유합니다.',
    tags: ['ghidra', 'reverse-engineering', 'decompiler', 'binary-analysis', 'nsa'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 78,
    views_count: 16400,
    created_at: new Date(Date.now() - 6 * 3600000).toISOString(),
    profiles: {
      id: 'user58',
      username: 'reverse_pro',
      display_name: 'Reverse Engineering Pro',
      points: 15670,
      reputation: 4780
    }
  },
  {
    id: 't4',
    user_id: 'user59',
    type: 'feed' as const,
    category: 'tools',
    title: 'BloodHound 5.0 - Active Directory 공격 경로 시각화 신기능',
    content: 'BloodHound 5.0이 출시됐습니다. 새로운 Cypher 쿼리 엔진으로 분석 속도가 10배 향상됐고, Azure AD 통합 분석 기능이 추가됐습니다. 하이브리드 환경에서 온프레미스 AD에서 Azure로의 공격 경로를 자동으로 찾아줍니다. 실전 활용 사례를 공유합니다.',
    tags: ['bloodhound', 'active-directory', 'graph-theory', 'azure-ad', 'pentest'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 69,
    views_count: 14200,
    created_at: new Date(Date.now() - 8 * 3600000).toISOString(),
    profiles: {
      id: 'user59',
      username: 'ad_hacker',
      display_name: 'AD Hacker',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 't5',
    user_id: 'user60',
    type: 'feed' as const,
    category: 'tools',
    title: 'Metasploit Framework 6.4 - 새로운 익스플로잇 모듈 50개 추가',
    content: 'Metasploit 6.4 업데이트에서 50개의 새로운 익스플로잇 모듈이 추가됐습니다. CVE-2025 취약점들에 대한 모듈이 대거 포함됐으며, 특히 클라우드 환경 타겟 모듈이 강화됐습니다. 새로운 post-exploitation 모듈과 함께 실전 활용 가이드를 제공합니다.',
    tags: ['metasploit', 'exploitation', 'framework', 'pentest', 'ruby'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 64,
    views_count: 12700,
    created_at: new Date(Date.now() - 10 * 3600000).toISOString(),
    profiles: {
      id: 'user60',
      username: 'msf_expert',
      display_name: 'MSF Expert',
      points: 13890,
      reputation: 4230
    }
  },
  {
    id: 't6',
    user_id: 'user61',
    type: 'feed' as const,
    category: 'tools',
    title: 'Wireshark 4.2 - HTTP/3 QUIC 프로토콜 완벽 분석 지원',
    content: 'Wireshark 4.2에서 HTTP/3와 QUIC 프로토콜 분석이 완벽하게 지원됩니다. 암호화된 QUIC 트래픽도 키 로그를 통해 복호화할 수 있으며, 스트림별 분석과 재조립 기능이 추가됐습니다. 실전 네트워크 포렌식 활용 사례를 공유합니다.',
    tags: ['wireshark', 'packet-analysis', 'http3', 'quic', 'network'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 55,
    views_count: 10600,
    created_at: new Date(Date.now() - 12 * 3600000).toISOString(),
    profiles: {
      id: 'user61',
      username: 'packet_guru',
      display_name: 'Packet Analysis Guru',
      points: 11670,
      reputation: 3560
    }
  },
  {
    id: 't7',
    user_id: 'user62',
    type: 'feed' as const,
    category: 'tools',
    title: 'Nmap 7.95 NSE 스크립트 엔진 - Lua 5.4 업그레이드',
    content: 'Nmap 7.95에서 NSE 스크립트 엔진이 Lua 5.4로 업그레이드됐습니다. 성능이 크게 향상됐고, 새로운 라이브러리 지원으로 더 복잡한 스크립트 작성이 가능해졌습니다. 클라우드 서비스 탐지 스크립트 10개와 함께 커스텀 NSE 작성 가이드를 공유합니다.',
    tags: ['nmap', 'nse', 'lua', 'port-scanning', 'reconnaissance'],
    status: 'open',
    is_pinned: false,
    likes_count: 1345,
    replies_count: 52,
    views_count: 9800,
    created_at: new Date(Date.now() - 14 * 3600000).toISOString(),
    profiles: {
      id: 'user62',
      username: 'nmap_ninja',
      display_name: 'Nmap Ninja',
      points: 10890,
      reputation: 3290
    }
  },
  {
    id: 't8',
    user_id: 'user63',
    type: 'feed' as const,
    category: 'tools',
    title: 'Frida 16.0 - iOS 17 완벽 지원 및 성능 최적화',
    content: 'Frida 16.0이 iOS 17을 완벽하게 지원합니다. 새로운 Swift 런타임 후킹 API가 추가됐고, 메모리 사용량이 30% 감소했습니다. Android 14의 새로운 보안 기능도 우회할 수 있으며, 실전 모바일 앱 분석 스크립트 20개를 공유합니다.',
    tags: ['frida', 'dynamic-analysis', 'hooking', 'mobile', 'instrumentation'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 67,
    views_count: 13400,
    created_at: new Date(Date.now() - 16 * 3600000).toISOString(),
    profiles: {
      id: 'user63',
      username: 'frida_master',
      display_name: 'Frida Master',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 't9',
    user_id: 'user64',
    type: 'feed' as const,
    category: 'tools',
    title: 'SQLMap 1.8 - NoSQL Injection 탐지 기능 대폭 강화',
    content: 'SQLMap 1.8에서 NoSQL Injection 탐지 기능이 대폭 강화됐습니다. MongoDB, CouchDB, Cassandra 등 다양한 NoSQL 데이터베이스를 지원하며, GraphQL 쿼리 인젝션 탐지도 추가됐습니다. 새로운 tamper 스크립트와 함께 실전 활용법을 공유합니다.',
    tags: ['sqlmap', 'sql-injection', 'nosql', 'automation', 'web-security'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 59,
    views_count: 11200,
    created_at: new Date(Date.now() - 18 * 3600000).toISOString(),
    profiles: {
      id: 'user64',
      username: 'sqli_hunter',
      display_name: 'SQLi Hunter',
      points: 12340,
      reputation: 3780
    }
  },
  {
    id: 't10',
    user_id: 'user65',
    type: 'feed' as const,
    category: 'tools',
    title: 'Cobalt Strike 4.9 - Malleable C2 프로파일 AI 생성 기능',
    content: 'Cobalt Strike 4.9에 AI 기반 Malleable C2 프로파일 생성 기능이 추가됐습니다. 타겟 환경의 정상 트래픽을 학습하여 자동으로 최적화된 프로파일을 생성합니다. 새로운 OPSEC 체크 기능과 함께 레드팀 작전 효율이 크게 향상됐습니다.',
    tags: ['cobalt-strike', 'c2', 'redteam', 'malleable', 'opsec'],
    status: 'open',
    is_pinned: false,
    likes_count: 2234,
    replies_count: 84,
    views_count: 17800,
    created_at: new Date(Date.now() - 20 * 3600000).toISOString(),
    profiles: {
      id: 'user65',
      username: 'redteam_lead',
      display_name: 'Red Team Lead',
      points: 16890,
      reputation: 5120
    }
  },
  {
    id: 't11',
    user_id: 'user66',
    type: 'feed' as const,
    category: 'tools',
    title: 'Impacket 최신 버전 - Kerberos 공격 도구 업데이트',
    content: 'Impacket 라이브러리의 최신 버전에서 Kerberos 공격 도구들이 대폭 업데이트됐습니다. GetUserSPNs, GetNPUsers, secretsdump 등 핵심 도구들의 성능이 개선됐고, Windows Server 2025 지원이 추가됐습니다. 실전 AD 공격 시나리오와 함께 활용법을 공유합니다.',
    tags: ['impacket', 'kerberos', 'active-directory', 'python', 'pentest'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 63,
    views_count: 12500,
    created_at: new Date(Date.now() - 22 * 3600000).toISOString(),
    profiles: {
      id: 'user66',
      username: 'kerberos_pro',
      display_name: 'Kerberos Professional',
      points: 13670,
      reputation: 4210
    }
  },
  {
    id: 't12',
    user_id: 'user67',
    type: 'feed' as const,
    category: 'tools',
    title: 'OWASP ZAP 2.15 - API 보안 테스트 자동화 기능',
    content: 'OWASP ZAP 2.15에서 API 보안 테스트 자동화 기능이 크게 강화됐습니다. OpenAPI/Swagger 스펙 자동 임포트, GraphQL 인트로스펙션 분석, JWT 토큰 자동 갱신 등이 추가됐습니다. CI/CD 파이프라인 통합 가이드와 함께 실전 활용법을 공유합니다.',
    tags: ['owasp-zap', 'api-security', 'automation', 'ci-cd', 'web-security'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 56,
    views_count: 10400,
    created_at: new Date(Date.now() - 24 * 3600000).toISOString(),
    profiles: {
      id: 'user67',
      username: 'zap_expert',
      display_name: 'ZAP Expert',
      points: 11450,
      reputation: 3450
    }
  },
  {
    id: 't13',
    user_id: 'user68',
    type: 'feed' as const,
    category: 'tools',
    title: 'Volatility 3 메모리 포렌식 - Windows 11 24H2 완벽 지원',
    content: 'Volatility 3가 Windows 11 24H2를 완벽하게 지원합니다. 새로운 커널 구조 변경사항이 모두 반영됐고, 플러그인 성능이 크게 향상됐습니다. 실제 랜섬웨어 사고 대응에서 사용한 메모리 분석 기법과 커스텀 플러그인을 공유합니다.',
    tags: ['volatility', 'memory-forensics', 'dfir', 'windows', 'incident-response'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 68,
    views_count: 13100,
    created_at: new Date(Date.now() - 26 * 3600000).toISOString(),
    profiles: {
      id: 'user68',
      username: 'forensics_pro',
      display_name: 'Forensics Professional',
      points: 14230,
      reputation: 4340
    }
  },
  {
    id: 't14',
    user_id: 'user69',
    type: 'feed' as const,
    category: 'tools',
    title: 'Responder 3.1 - LLMNR/NBT-NS 포이즈닝 새로운 우회 기법',
    content: 'Responder 3.1에서 최신 Windows 보안 기능을 우회하는 새로운 기법이 추가됐습니다. LDAP 서명 강제 환경에서도 동작하는 릴레이 공격 모드와, SMB 서명 우회 기법이 포함됐습니다. 실전 내부망 침투 시나리오와 함께 활용법을 공유합니다.',
    tags: ['responder', 'llmnr', 'poisoning', 'mitm', 'internal-pentest'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 61,
    views_count: 11600,
    created_at: new Date(Date.now() - 28 * 3600000).toISOString(),
    profiles: {
      id: 'user69',
      username: 'mitm_master',
      display_name: 'MITM Master',
      points: 12890,
      reputation: 3890
    }
  },
  {
    id: 't15',
    user_id: 'user70',
    type: 'feed' as const,
    category: 'tools',
    title: 'Hashcat 6.2.6 - GPU 크래킹 성능 30% 향상',
    content: 'Hashcat 6.2.6에서 GPU 크래킹 성능이 30% 향상됐습니다. NVIDIA RTX 4090과 AMD RX 7900 XTX 최적화가 적용됐고, 새로운 해시 알고리즘 20개가 추가됐습니다. 효율적인 룰셋 작성법과 함께 실전 패스워드 크래킹 전략을 공유합니다.',
    tags: ['hashcat', 'password-cracking', 'gpu', 'brute-force', 'hash'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 72,
    views_count: 14800,
    created_at: new Date(Date.now() - 30 * 3600000).toISOString(),
    profiles: {
      id: 'user70',
      username: 'hash_cracker',
      display_name: 'Hash Cracker',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 't16',
    user_id: 'user71',
    type: 'feed' as const,
    category: 'tools',
    title: 'Mimikatz 2.2.0 - Windows Credential Guard 우회 기법',
    content: 'Mimikatz 2.2.0에서 Windows Credential Guard를 우회하는 새로운 기법이 추가됐습니다. 커널 드라이버를 사용하지 않고도 LSASS 메모리에서 크리덴셜을 추출할 수 있으며, EDR 탐지를 회피하는 새로운 난독화 기법도 적용됐습니다.',
    tags: ['mimikatz', 'credential-dumping', 'lsass', 'windows', 'post-exploitation'],
    status: 'open',
    is_pinned: false,
    likes_count: 2123,
    replies_count: 79,
    views_count: 16700,
    created_at: new Date(Date.now() - 32 * 3600000).toISOString(),
    profiles: {
      id: 'user71',
      username: 'cred_hunter',
      display_name: 'Credential Hunter',
      points: 15670,
      reputation: 4780
    }
  },
  {
    id: 't17',
    user_id: 'user72',
    type: 'feed' as const,
    category: 'tools',
    title: 'Sliver C2 1.6 - 오픈소스 대안 Cobalt Strike 킬러',
    content: 'Sliver C2 프레임워크 1.6이 출시됐습니다. Cobalt Strike의 오픈소스 대안으로 주목받고 있으며, 멀티 플랫폼 지원, 동적 C2 프로파일, 강력한 OPSEC 기능을 제공합니다. 실제 레드팀 작전에서 사용한 경험과 함께 Cobalt Strike와의 비교 분석을 공유합니다.',
    tags: ['sliver', 'c2', 'redteam', 'opensource', 'implant'],
    status: 'open',
    is_pinned: false,
    likes_count: 2456,
    replies_count: 91,
    views_count: 19400,
    created_at: new Date(Date.now() - 34 * 3600000).toISOString(),
    profiles: {
      id: 'user72',
      username: 'c2_architect',
      display_name: 'C2 Architect',
      points: 16230,
      reputation: 4980
    }
  },
  {
    id: 't18',
    user_id: 'user73',
    type: 'feed' as const,
    category: 'tools',
    title: 'Radare2 5.9 - 바이너리 분석 워크플로우 혁신',
    content: 'Radare2 5.9에서 사용자 경험이 크게 개선됐습니다. 새로운 GUI 프론트엔드 Cutter 2.3과의 통합이 강화됐고, 디버거 성능이 향상됐습니다. RISC-V와 ARM64 아키텍처 지원도 완벽해졌습니다. 실전 바이너리 분석 워크플로우를 공유합니다.',
    tags: ['radare2', 'binary-analysis', 'reverse-engineering', 'debugger', 'disassembler'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 64,
    views_count: 12300,
    created_at: new Date(Date.now() - 36 * 3600000).toISOString(),
    profiles: {
      id: 'user73',
      username: 'r2_ninja',
      display_name: 'Radare2 Ninja',
      points: 13890,
      reputation: 4230
    }
  },
  {
    id: 't19',
    user_id: 'user74',
    type: 'feed' as const,
    category: 'tools',
    title: 'Amass 4.0 - OSINT 정찰 자동화 플랫폼',
    content: 'Amass 4.0이 완전히 재작성됐습니다. 새로운 아키텍처로 성능이 5배 향상됐고, 100개 이상의 데이터 소스를 지원합니다. 서브도메인 열거, ASN 매핑, 관계 그래프 생성 등 종합적인 OSINT 정찰이 가능합니다. 실전 버그바운티 정찰 워크플로우를 공유합니다.',
    tags: ['amass', 'osint', 'reconnaissance', 'subdomain', 'enumeration'],
    status: 'open',
    is_pinned: false,
    likes_count: 1789,
    replies_count: 67,
    views_count: 13200,
    created_at: new Date(Date.now() - 38 * 3600000).toISOString(),
    profiles: {
      id: 'user74',
      username: 'osint_master',
      display_name: 'OSINT Master',
      points: 14670,
      reputation: 4450
    }
  },
  {
    id: 't20',
    user_id: 'user75',
    type: 'feed' as const,
    category: 'tools',
    title: 'Trivy 0.50 - 컨테이너 보안 스캐너 완벽 가이드',
    content: 'Trivy 0.50에서 Kubernetes 클러스터 스캔 기능이 추가됐습니다. 컨테이너 이미지뿐만 아니라 IaC 파일, 설정 오류, 시크릿 노출까지 종합적으로 스캔합니다. CI/CD 파이프라인 통합 방법과 함께 실전 DevSecOps 워크플로우를 공유합니다.',
    tags: ['trivy', 'container-security', 'vulnerability-scanner', 'kubernetes', 'devsecops'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 59,
    views_count: 11400,
    created_at: new Date(Date.now() - 40 * 3600000).toISOString(),
    profiles: {
      id: 'user75',
      username: 'container_sec',
      display_name: 'Container Security',
      points: 12450,
      reputation: 3780
    }
  },
  {
    id: 't21',
    user_id: 'user76',
    type: 'feed' as const,
    category: 'tools',
    title: 'Ffuf 2.1 - 웹 퍼징 도구 성능 최적화',
    content: 'Ffuf 2.1에서 퍼징 성능이 크게 향상됐습니다. 새로운 매칭 필터와 재귀 퍼징 기능이 추가됐고, 결과 출력 포맷이 다양해졌습니다. API 엔드포인트 발견, 파라미터 퍼징, 서브도메인 열거 등 실전 활용 사례와 함께 최적화된 워드리스트를 공유합니다.',
    tags: ['ffuf', 'fuzzing', 'web-security', 'directory-bruteforce', 'go'],
    status: 'open',
    is_pinned: false,
    likes_count: 1456,
    replies_count: 54,
    views_count: 10200,
    created_at: new Date(Date.now() - 42 * 3600000).toISOString(),
    profiles: {
      id: 'user76',
      username: 'fuzzing_pro',
      display_name: 'Fuzzing Professional',
      points: 11230,
      reputation: 3410
    }
  },
  {
    id: 't22',
    user_id: 'user77',
    type: 'feed' as const,
    category: 'tools',
    title: 'Jadx 1.5 - Android APK 디컴파일러 최신 기능',
    content: 'Jadx 1.5에서 Kotlin 코루틴과 Jetpack Compose 디컴파일이 크게 개선됐습니다. 난독화된 코드의 가독성이 향상됐고, 리소스 파일 분석 기능도 강화됐습니다. 실전 Android 앱 리버싱 워크플로우와 함께 유용한 플러그인을 공유합니다.',
    tags: ['jadx', 'android', 'decompiler', 'apk', 'reverse-engineering'],
    status: 'open',
    is_pinned: false,
    likes_count: 1678,
    replies_count: 62,
    views_count: 12100,
    created_at: new Date(Date.now() - 44 * 3600000).toISOString(),
    profiles: {
      id: 'user77',
      username: 'android_rev',
      display_name: 'Android Reverser',
      points: 12890,
      reputation: 3890
    }
  },
  {
    id: 't23',
    user_id: 'user78',
    type: 'feed' as const,
    category: 'tools',
    title: 'Semgrep 1.60 - SAST 도구 커스텀 룰 작성 가이드',
    content: 'Semgrep 1.60의 강력한 커스텀 룰 작성 기능을 활용하여 프로젝트 특화 취약점을 탐지하는 방법을 정리했습니다. 실제 코드 리뷰에서 발견한 취약점 패턴을 바탕으로 작성한 룰 30개를 공유하며, CI/CD 통합 방법도 함께 제공합니다.',
    tags: ['semgrep', 'sast', 'code-analysis', 'security', 'ci-cd'],
    status: 'open',
    is_pinned: false,
    likes_count: 1345,
    replies_count: 51,
    views_count: 9600,
    created_at: new Date(Date.now() - 46 * 3600000).toISOString(),
    profiles: {
      id: 'user78',
      username: 'sast_expert',
      display_name: 'SAST Expert',
      points: 10670,
      reputation: 3230
    }
  },
  {
    id: 't24',
    user_id: 'user79',
    type: 'feed' as const,
    category: 'tools',
    title: 'Shodan CLI 고급 활용법 - IoT 기기 대규모 스캔',
    content: 'Shodan CLI를 활용한 고급 검색 쿼리와 자동화 스크립트를 공유합니다. 특정 취약점이 있는 기기를 대규모로 찾아내고, 지리적 분포를 분석하며, 시계열 데이터를 추적하는 방법을 다룹니다. 실제 버그바운티에서 사용한 쿼리 50개를 제공합니다.',
    tags: ['shodan', 'iot', 'reconnaissance', 'osint', 'scanning'],
    status: 'open',
    is_pinned: false,
    likes_count: 1890,
    replies_count: 71,
    views_count: 14300,
    created_at: new Date(Date.now() - 48 * 3600000).toISOString(),
    profiles: {
      id: 'user79',
      username: 'shodan_ninja',
      display_name: 'Shodan Ninja',
      points: 13450,
      reputation: 4120
    }
  },
  {
    id: 't25',
    user_id: 'user80',
    type: 'feed' as const,
    category: 'tools',
    title: 'Yara 4.5 - 멀웨어 탐지 룰 작성 베스트 프랙티스',
    content: 'Yara 4.5의 새로운 기능과 효율적인 룰 작성 방법을 정리했습니다. 성능 최적화 팁, 오탐 최소화 전략, 모듈 활용법 등을 다루며, 실제 멀웨어 분석에서 사용한 고급 룰 40개를 공유합니다. 대규모 파일 스캔 최적화 방법도 포함됩니다.',
    tags: ['yara', 'malware-detection', 'pattern-matching', 'threat-hunting', 'rules'],
    status: 'open',
    is_pinned: false,
    likes_count: 1567,
    replies_count: 58,
    views_count: 11100,
    created_at: new Date(Date.now() - 50 * 3600000).toISOString(),
    profiles: {
      id: 'user80',
      username: 'yara_master',
      display_name: 'Yara Master',
      points: 12340,
      reputation: 3780
    }
  }
];